import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})

export class MainService {

  public memberInfo: any;

  constructor(
    private restful: RestfulService
  ) {
  }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.log(error.message || error);
    return Promise.reject(error.message || error);
  }

  // 공지사항 가져오기
  getBoardNotice(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardNotice'
      }, {
      }
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // kraiasns 가져오기
  getBoardKraiasns(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardKraiasns'
      }, {
      }
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 뉴스 가져오기
  getBoardNews(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardNews'
      }, {
      }
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 세미나 가져오기 -> 환경ㆍ에너지로 변경 2020-05-28 송영석
  getBoardSeminar(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardSeminar'
      }, {
      }
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 창립기념일 가져오기
  getCompanySchedule(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getCompanySchedule'
      }, {}
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 회원사일정 가져오기
  getBoardCompanyMonth(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardCompanyMonth'
      }, {}
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  getBoardCompanyNews(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardCompanyNews'
      }, {}
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 배너 리스트 가져오기
  getBannerList(): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'banner',
        version: '1.0',
        action: 'getBannerList'
      }, {}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 메인 게시판 리스트 가져오기
  getBoardListLimit( params ): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'board',
        version: '1.0',
        action: 'getBoardListLimit'
      }, params
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 팝업 리스트 가져오기
  getPopupList( params ): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'board',
        version: '1.0',
        action: 'getPopupList'
      }, params
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }
}
